export default {
    BackendUrl: 'http://localhost:4000',
    WebAppUrl: 'http://localhost:8081',
    Inlinemanual: false,
    EnforceSSL: false,
};
